var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1375 14.025L10.3875 2.9875C10.325 2.7 10.0625 2.5 9.7625 2.5C5.75 2.5 2.5 5.75 2.5 9.7625V16.8875C2.5 17.3125 2.9125 17.625 3.325 17.5L12.7 14.7875C13.025 14.7 13.225 14.3625 13.1375 14.025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 17.1C13.8125 16.75 13.45 16.5375 13.1 16.6375L2.9625 19.5875C2.6875 19.675 2.5 19.925 2.5 20.2125V20.2375C2.5 24.25 5.75 27.5 9.7625 27.5H15.6625C16.075 27.5 16.3875 27.1125 16.2875 26.7L13.9 17.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2375 2.5H13.05C12.6375 2.5 12.325 2.8875 12.425 3.3L18.35 27.0125C18.425 27.3 18.675 27.5 18.975 27.5H20.225C24.25 27.5 27.5 24.25 27.5 20.2375V9.7625C27.5 5.75 24.25 2.5 20.2375 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconFull);
export default __webpack_public_path__ + "static/media/home-icon_full.f513c5d5920015d603c38cad69ae67fd.svg";
export { ForwardRef as ReactComponent };